var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStatistics30Days = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 8.667h1.333V7.334H2zm0 2.667h1.333V10H2zM2 6h1.333V4.667H2zm2.667 2.667H14V7.334H4.667zm0 2.667H14V10H4.667zm0-6.667V6H14V4.667zM2 8.667h1.333V7.334H2zm0 2.667h1.333V10H2zM2 6h1.333V4.667H2zm2.667 2.667H14V7.334H4.667zm0 2.667H14V10H4.667zm0-6.667V6H14V4.667z"
})));
export default SvgStatistics30Days;